/** These are values hard coded into aim */
export enum STRInterval {
  DAYS = 'Days',
  HOURS = 'Hours',
  WEEKS = 'Weeks',
  MONTHS = 'Months',
}
